import project01 from "./../img/projects/TaskPro.png";
import project01Big from "./../img/projects/TaskPro.png";

import project02 from "./../img/projects/Filmoteka.jpg";
import project02Big from "./../img/projects/Filmoteka.jpg";

import project03 from "./../img/projects/IceCream.png";
import project03Big from "./../img/projects/IceCream.png";

import project04 from "./../img/projects/WebStudio.png";
import project04Big from "./../img/projects/WebStudio.png";

import project05 from "./../img/projects/Chat.png";
import project05Big from "./../img/projects/Chat.png";

import project06 from "./../img/projects/Different.png";
import project06Big from "./../img/projects/Different.png";

import project07 from "./../img/projects/Kinoposhuk.png";
import project07Big from "./../img/projects/Kinoposhuk.png";

import project08 from "./../img/projects/BookGame-shop.png";
import project08Big from "./../img/projects/BookGame-shop.png";
const projects = [
  {
    title: "TaskPro",
    skills: "JS, React.js, Redux, Redux Toolkit, Node.js",
    img: project01,
    imgBig: project01Big,
    gitHubLink: "https://github.com/resinner/TaskPro-FrontEnd-Team6",
    gitHubUrl: "https://resinner.github.io/TaskPro-FrontEnd-Team6/",
  },
  {
    title: "Filmoteka",
    img: project02,
    imgBig: project02Big,
    skills: "HTML, SASS, JS, Bootstrap-Icons, REST-API",
    gitHubLink: "https://github.com/mamamamamaa/filmoteka-team-project",
    gitHubUrl: "https://mamamamamaa.github.io/filmoteka-team-project/",
  },
  {
    title: "IceCream",
    img: project03,
    imgBig: project03Big,
    skills: "HTML, SASS, JS",
    gitHubLink: "https://palkaz.github.io/djedaj-cod-ice-next/",
    gitHubUrl: "https://palkaz.github.io/djedaj-cod-ice-next/#how-its-made",
  },
  {
    title: "WebStudio",
    img: project04,
    imgBig: project04Big,
    skills: "HTML, SASS, JS",
    gitHubLink: "https://github.com/BogdanKaleniuk/goit-markup-hw-08",
    gitHubUrl: "https://bogdankaleniuk.github.io/goit-markup-hw-08/",
  },
  {
    title: "Chat",
    img: project05,
    imgBig: project05Big,
    skills: "JS, React.js, Node.js, MongoDB",
    gitHubLink: "https://github.com/BogdanKaleniuk/ChatFront",
    gitHubUrl: "https://jocular-shortbread-87199c.netlify.app/",
  },

  {
    title: "Different",
    img: project06,
    imgBig: project06Big,
    skills: "JS, React.js, Redux / Redux Toolkit, Tailwind CSS, API",
    gitHubLink: "https://github.com/BogdanKaleniuk/testforteam",
    gitHubUrl: "https://bogdankaleniuk.github.io/testforteam/",
  },

  {
    title: "Kinoposhuk",
    img: project07,
    imgBig: project07Big,
    skills: "JS, React.js, Redux / Redux Toolkit, Tailwind CSS, API",
    gitHubLink: "https://github.com/BogdanKaleniuk/Kinoposhuk/",
    gitHubUrl: "https://kinoposhukua.vercel.app/",
  },
  {
    title: "BookGame-shop",
    img: project08,
    imgBig: project08Big,
    skills: "JS, React.js, CSS, API",
    gitHubLink: "https://github.com/BogdanKaleniuk/BookShop",
    gitHubUrl: "https://book-game-shop.vercel.app/",
  },
];

export { projects };
